import { useEffect } from "react";
import { batch, useSignal } from "@preact/signals-react";
import { postSubmit } from "@ui-seeker/utils";

import { WEBBACK_V2_API } from "@constants";
import {isLoadingCommonFilters, commonFiltersValue, isSystemBusy} from "@signals";
import {elementsInLoading, marketplacesLBBOverviewIsEmpty, resetMarketplacesLostBuyBoxOverviewSignal} from "../signals";


export default function useLostBuyBoxOverviewTableData() {

	const isLoadingOverviewTable = useSignal(false)
	const overviewTableData = useSignal([])
	const overviewTableReasonsInfo = useSignal({})

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {

			isLoadingOverviewTable.value = true
			resetMarketplacesLostBuyBoxOverviewSignal()

			postSubmit(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-overview/overview-table`, commonFiltersValue.value).then((res) => {
				if (!res?.tableData?.length) {
					isLoadingCommonFilters.value = false
					marketplacesLBBOverviewIsEmpty.value = true
				}
				overviewTableData.value = res.tableData
				overviewTableReasonsInfo.value = res.reasonsInfo
                isLoadingOverviewTable.value = false
			}).catch(() => {
				isSystemBusy.value = true
                isLoadingOverviewTable.value = false
				isLoadingCommonFilters.value = false
            })
		})
	}, [isLoadingCommonFilters.value]);


	useEffect(() => {
		if (isLoadingOverviewTable.value)
			elementsInLoading.value = [...elementsInLoading.value, 'tableOverviews']
		else
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'tableOverviews')
	}, [isLoadingOverviewTable.value])

	return {
		overviewTableData: overviewTableData.value,
		overviewTableReasonsInfo: overviewTableReasonsInfo.value,
        isLoadingOverviewTable: isLoadingOverviewTable.value
	}
}